import React from 'react'

import ELocale from '../../types/locales'

type _AppContext = {
  locale: ELocale
  uid: string | null
  useElastic?: boolean
}

type Composition = {
  useAppContext: () => _AppContext
}

type AppContextProps = {
  children: React.ReactNode
  value: _AppContext
}

const Context = React.createContext<_AppContext>({} as _AppContext)

const AppContext: React.FC<AppContextProps> & Composition = (props) => {
  return <Context.Provider value={props.value}>{props.children}</Context.Provider>
}

const useAppContext = () => {
  return React.useContext<_AppContext>(Context)
}

AppContext.useAppContext = useAppContext

export default AppContext
